// Mirrors backend/src/pdfTemplates/designA/designAFormatters.js's
// bankAccountToConfig exactly. `bank` is the raw row from
// apiservice/accounts.js's getPrimaryBankAccountApi (or null if nothing is
// marked primary in Chart of Accounts yet).
export function bankAccountToConfig(bank) {
  if (!bank) return null;
  return {
    bankName: bank.bank_name || null,
    accountNameAsPerBank: bank.bank_acc_name_as_per_bank || null,
    accountNo: bank.bank_acc_number || null,
    branch: bank.bank_branch || null,
    ifsc: bank.ifsc_code || null,
    swiftCode: bank.swift_code || null,
    ibanNumber: bank.iban_no || null,
  };
}
